module.exports = __webpack_public_path__ + "static/media/aler-tcon.96ecc2a8.png";